import React, { useState, useEffect } from 'react'
import { Spinner } from '../ui/spinner'
import masksApi from '../../services/masksApi'
import useMaskStore from '../../stores/maskStore'

const MaskPreview = ({ maskId, className = '' }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)
  const [maskUrl, setMaskUrl] = useState(null)
  const mask = useMaskStore(state => 
    state.masks.find(m => m._id === maskId)
  )

  useEffect(() => {
    const loadMask = async () => {
      if (!mask || mask.status !== 'completed') return
      
      try {
        setIsLoading(true)
        const response = await masksApi.getMask(maskId)
        setMaskUrl(response.url)
      } catch (error) {
        console.error('Failed to load mask:', error)
        setError(error.message)
      } finally {
        setIsLoading(false)
      }
    }

    if (maskId) {
      loadMask()
    }

    return () => {
      if (maskUrl) {
        URL.revokeObjectURL(maskUrl)
      }
    }
  }, [maskId, mask?.status])

  if (isLoading) {
    return (
      <div className="w-full h-32 bg-gray-800 rounded-lg flex items-center justify-center">
        <Spinner className="text-blue-500" />
      </div>
    )
  }

  if (error) {
    return (
      <div className="w-full h-32 bg-gray-800 rounded-lg flex items-center justify-center text-red-400 text-sm">
        Failed to load mask
      </div>
    )
  }

  return (
    <div className="w-full h-32 bg-gray-800 rounded-lg overflow-hidden">
      <img 
        src={maskUrl} 
        alt="Generated mask"
        className="w-full h-full object-contain"
      />
    </div>
  )
}

export default MaskPreview 